import { render, staticRenderFns } from "./AdminSendedTickets.vue?vue&type=template&id=6e1deb6f&"
import script from "./AdminSendedTickets.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminSendedTickets.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports